/**
 * Route definition for /list-item
 * Renders the ListItemContainer component.
 *
 * @module routes/list-item
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ListItemContainer from "@/containers/ListItem"

export const Route = createFileRoute('/$locale/list-item')({
  component: ListItem,
})

/**
 * List item page component.
 * Renders the ListItem container for listing NFTs on the marketplace.
 *
 * @returns {React.ReactElement}
 */
function ListItem() {
  return (
    <>
      <ListItemContainer />
    </>
  )
}